import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-turf',
  templateUrl: './turf.component.html',
  styleUrls: ['./turf.component.scss']
})
export class TurfComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
